import actions from './actions'
import mutations from './mutations'

const state = {
  shipping: {
    address: {
      destination: {}
    },
    services: [],
    currentService: {},
    price: null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
